module.exports = __webpack_public_path__ + "img/krathong_7.6bb22e4c.png";